var _path, _g, _rect, _rect2, _rect3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconQnaAni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 22,
    viewBox: "0 0 53 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40879_22480",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 0,
    width: 34,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 21V1C19 0.447715 19.4477 0 20 0H52C52.5523 0 53 0.447716 53 1V21C53 21.5523 52.5523 22 52 22H20C19.4477 22 19 21.5523 19 21Z",
    fill: "url(#paint0_linear_40879_22480)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40879_22480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 21V1C19 0.447715 19.4477 0 20 0H52C52.5523 0 53 0.447716 53 1V21C53 21.5523 52.5523 22 52 22H20C19.4477 22 19 21.5523 19 21Z",
    fill: "url(#paint1_linear_40879_22480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 9L53 22H19L36 9Z",
    fill: "url(#paint2_linear_40879_22480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7851 12.071L19 0H53L37.2149 12.071C36.4978 12.6193 35.5022 12.6193 34.7851 12.071Z",
    fill: "url(#paint3_linear_40879_22480)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 4,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#7783A1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 4,
    y: 10,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#7783A1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 8,
    y: 16,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#7783A1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40879_22480",
    x1: 19,
    y1: 11,
    x2: 53,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F84EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503154,
    stopColor: "#1F5CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40879_22480",
    x1: 19,
    y1: 11,
    x2: 53,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC42E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD15C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40879_22480",
    x1: 36,
    y1: 9,
    x2: 36,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC73A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40879_22480",
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 13.4483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBEF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQnaAni);
export default __webpack_public_path__ + "static/media/icon_qna_ani.9b99619c9194544b3255a7b867eb1572.svg";
export { ForwardRef as ReactComponent };